import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import * as React from 'react';
import { useArrayState } from '../../hooks';
import { ClassNames } from '../../utils/classNames';
/** The React context object driving the modals */

var ModalContext = React.createContext({
  modalLayerReference: undefined,
  modals: [],
  addModal: undefined,
  removeModal: undefined
});
/**
 * use the modal context - !!mostly for internal use!!
 * if you want to dispatch your own modal you should use useModal or useDialog (or some other similar hook)
 * if you want to access the ref, you should use useModalLayerElement
 */

export var useModalContext = function useModalContext() {
  return React.useContext(ModalContext);
};
/** Access the reference to the modal layer element which modals are portaled into by default */

export var useModalLayerElement = function useModalLayerElement() {
  return useModalContext().modalLayerReference;
};
/**
 * Provides modal context to its children allowing the use of context-based hooks like useModal (which will dispatch a modal that can
 * resolve a promise) and renders a div which modals will portal into
 */

export var ModalProvider = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      modalLayerProps = _ref.modalLayerProps;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      modalLayerReference = _React$useState2[0],
      setModalLayerReference = _React$useState2[1];

  React.useImperativeHandle(ref, function () {
    return modalLayerReference;
  }, [modalLayerReference]); // set the reference to the modal layer element to context

  var setRef = React.useCallback(function (node) {
    setModalLayerReference(node);
  }, []);

  var _useArrayState = useArrayState([]),
      _useArrayState2 = _slicedToArray(_useArrayState, 2),
      modals = _useArrayState2[0],
      _useArrayState2$ = _useArrayState2[1],
      addModal = _useArrayState2$.push,
      removeModal = _useArrayState2$.pull;

  var _a = modalLayerProps,
      className = _a.className,
      modalProps = __rest(_a, ["className"]);

  return React.createElement(ModalContext.Provider, {
    value: {
      modalLayerReference: modalLayerReference,
      modals: modals,
      addModal: addModal,
      removeModal: removeModal
    }
  }, children, React.createElement("div", Object.assign({}, modalProps, {
    className: ClassNames.concat('arm-modal-layer', className),
    ref: setRef
  }), modals.map(function (ModalComponent, index) {
    return React.createElement(ModalComponent, {
      key: index
    });
  })));
});
ModalProvider.defaultProps = {
  modalLayerProps: {}
};